import type { IWaitingTimeWithAuthorization } from '@frontend/components/interfaces';
import { fetchJson } from '@frontend/store/fetch';

export interface IOrganizationWaitingTimesAccess {
    canEditWaitingTimes: boolean;
    canReadWaitingTimes: boolean;
    hasWaitingTimes: boolean;
}

const queryParams = '?includeItemAuthorizations=canUpdateWaitingTime';

export async function fetchWaitingTimes(organizationId: string) {
    const result = await fetchJson(`/api/organizations/${organizationId}/waitingTimes${queryParams}`, 'GET');

    return result.json.items as IWaitingTimeWithAuthorization[];
}

export async function fetchWaitingTimesAccess(organizationId: string) {
    return (await (
        await fetchJson(`/api/organizations/${organizationId}/getWaitingTimesAccess`, 'GET')
    ).json) as IOrganizationWaitingTimesAccess;
}
